import "./Loader.css";

export default function Loader() {
  return (
    <div className="loader-frame">
      <div className="spinner"></div>
    </div>
  );
}
